/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {exchangeSessionToken} from '../api'

export const useMutationExchangeSessionToken = createReactQueryMutationHook('exchangeSessionToken', exchangeSessionToken)
